import { type SavedView } from "@features/sales-v3/hooks/use-saved-views-queries";

export const isTemplateViewCheck = (savedView: SavedView): boolean => {
  return savedView.is_default;
};
